/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Is_EmptyInputs */

const en_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Is Empty`)
};

const es_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La bóveda está vacía`)
};

const fr_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le coffre-fort est vide`)
};

const de_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault ist leer`)
};

const ja_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管庫は空です`)
};

const zh_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金库是空的`)
};

const ar_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخزنة فارغة`)
};

const id_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Kosong`)
};

const it_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Vault È Vuoto`)
};

const ru_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранилище пусто`)
};

const pt_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Cofre Está Vazio`)
};

const ko_vault_is_empty = /** @type {(inputs: Vault_Is_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보관소(Vault)가 비어있습니다`)
};

/**
* | output |
* | --- |
* | "Vault Is Empty" |
*
* @param {Vault_Is_EmptyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_is_empty = /** @type {((inputs?: Vault_Is_EmptyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Is_EmptyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_is_empty(inputs)
	if (locale === "es") return es_vault_is_empty(inputs)
	if (locale === "fr") return fr_vault_is_empty(inputs)
	if (locale === "de") return de_vault_is_empty(inputs)
	if (locale === "ja") return ja_vault_is_empty(inputs)
	if (locale === "zh") return zh_vault_is_empty(inputs)
	if (locale === "ar") return ar_vault_is_empty(inputs)
	if (locale === "id") return id_vault_is_empty(inputs)
	if (locale === "it") return it_vault_is_empty(inputs)
	if (locale === "ru") return ru_vault_is_empty(inputs)
	if (locale === "pt") return pt_vault_is_empty(inputs)
	return ko_vault_is_empty(inputs)
});